import AppRoutes from "./Routes/AppRoutes"; 
import { ToastProvider } from '../src/Components/ToastProvider';
import { useNavigate } from "react-router-dom";
import TokenService from "./Services/Token.service";
import useSessionTimeout from "./hooks/useSessionTimeout";
import { useState } from "react";

function App() {   
  const [isLoggedIn, setIsLoggedIn] = useState(!!TokenService.getUser()); 

  const navigate = useNavigate();

  const onTimeout = async () => {
    // optional: call backend to invalidate session / refresh token
    try {
      // await api.logoutOnTimeout(); // optional
    } catch (err) {
      // ignore
    }

    // remove local tokens
    TokenService.removeUser();
    setIsLoggedIn(false);
    // set flag (for other tabs) then navigate to session timeout page
    localStorage.setItem('app_session_timed_out', '1');
    localStorage.removeItem('last_active_time');
    navigate('/session-timeout');
  };

  useSessionTimeout(onTimeout);
  return (  
    <ToastProvider>
        <AppRoutes isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}/> 
    </ToastProvider>
  );
} 
export default App; 